import React from 'react';

export function PopularShows() {
  return <div>Popular</div>;
}

PopularShows.propTypes = {};
